"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function DatabasetreeBlueMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#BDF6FF",
    d: "M15.256 2.44a.516.516 0 00-.14-.314l-.02-.024a2.049 2.049 0 00-.403-.318 4.966 4.966 0 00-.649-.35A10.47 10.47 0 0012.578.91 16.405 16.405 0 0010.96.556l-.64-.093A12.37 12.37 0 008.966.354H7.532c-.471 0-.93.057-1.365.11l-.644.092a16.433 16.433 0 00-1.62.354c-.5.138-.99.313-1.465.524a4.96 4.96 0 00-.633.35c-.146.09-.28.197-.402.318v.024a.515.515 0 00-.141.314h-.06v11.212c0 1.208 3.028 2.143 7.047 2.143 4.02 0 7.048-.919 7.048-2.143V2.44h-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M8.29.805c3.132 0 5.533.85 6.306 1.382-.773.531-3.174 1.381-6.307 1.381-3.133 0-5.533-.85-6.306-1.381C2.756 1.655 5.156.805 8.289.805zm0-.805C4.261 0 1 1.381 1 2.187c0 .805 3.262 2.187 7.29 2.187 4.026 0 7.288-1.382 7.288-2.187C15.578 1.38 12.316 0 8.29 0zM8.29 16C4.132 16 1 15.05 1 13.785h.805c.077.403 2.183 1.41 6.484 1.41s6.403-1.023 6.484-1.414h.805C15.578 15.05 12.445 16 8.29 16zM8.29 12.013c-4.157 0-7.29-.95-7.29-2.215h.805c.077.403 2.183 1.41 6.484 1.41s6.403-1.023 6.484-1.414h.805c0 1.269-3.133 2.219-7.289 2.219zM8.29 8.026C4.132 8.026 1 7.076 1 5.811h.805c.077.403 2.183 1.41 6.484 1.41s6.403-1.023 6.484-1.414h.805c0 1.269-3.133 2.22-7.289 2.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M1.805 2.187H1v11.598h.805V2.187zM15.579 2.187h-.806v11.598h.806V2.187z"
  }));
}

DatabasetreeBlueMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
DatabasetreeBlueMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = DatabasetreeBlueMultitoneFilled;
exports["default"] = _default;